import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';
import ApprovalDialogBody from '../ApprovalDialogBody';

const ApproveDialog = ({ msg, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, APPROVE'
        }}
        header="Do you confirm that  you Approve this Exception?"
        body={<ApprovalDialogBody msg={msg} />}

    />;

export default ApproveDialog;